import Wheel from "@uiw/react-color-wheel";
import { useState, useContext } from "react";
import AppContext from "../context/AppProvider";

function ColorWheel() {
  const { settings, setSettings } = useContext(AppContext);
  const [hsva, setHsva] = useState({ h: 0, s: 0, v: 68, a: 1 });
  return (
    <Wheel
      color={hsva}
      onChange={(color) => {
        setHsva({ ...hsva, ...color.hsva });
        setSettings({ ...settings, color: color.hex });
      }}
    />
  );
}

export default ColorWheel;
